export enum DeviceType{
  DEFAULT,
  TABLET,
  MOBILE
}
